import { Navigate, RouteObject } from "react-router-dom";
import { DevelopmentContractPage } from "src/routes/developments/procurement/DevelopmentContractPage";
import { DevelopmentProcurementPage } from "src/routes/developments/procurement/DevelopmentProcurementPage";
import { PurchaseOrdersPage } from "src/routes/developments/purchase-orders/PurchaseOrdersPage";
import * as procurementPaths from "src/routing/domains/developments/procurement/procurementPaths";

/**
 * SideNav leaf routes for development procurement / purchase-orders section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentLegacySideNavLayout` in
 * `detail/developmentDetail.tsx`. The Contracts list and Purchase Orders live on the Beam branch
 * (`procurementBeamSideNavRoutes`).
 */
export const procurementSideNavRoutes: RouteObject[] = [
  { path: procurementPaths.developmentContractOverviewRoute.path, Component: DevelopmentContractPage },
  { path: procurementPaths.developmentContractLineItemsRoute.path, Component: DevelopmentContractPage },
  { path: procurementPaths.developmentUnitPricingRoute.path, Component: DevelopmentContractPage },
  { path: procurementPaths.developmentContractPurchaseOrdersRoute.path, Component: DevelopmentContractPage },
  { path: procurementPaths.developmentContractRoute.path, Component: RedirectToContractOverview },
];

/** Procurement leaves that have migrated to Beam's SideNavLayout and document-scroll page layouts. */
export const procurementBeamSideNavRoutes: RouteObject[] = [
  { path: procurementPaths.developmentProcurementRoute.path, Component: DevelopmentProcurementPage },
  { path: procurementPaths.developmentPurchaseOrdersRoute.path, Component: PurchaseOrdersPage },
];

function RedirectToContractOverview() {
  return <Navigate to="overview" replace relative="path" />;
}
